import { footerColumns } from "@/mocks/homeData";

export default function SiteFooter() {
  return (
    <footer className="w-full bg-background-200">
      <div className="mx-auto w-full px-4 pb-8 pt-12 md:px-6 md:pt-16">
        <div className="grid grid-cols-1 gap-10 border-b border-background-300/70 pb-10 lg:grid-cols-12 lg:gap-8">
          <div className="lg:col-span-5">
            <a href="#top" className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-xl" />
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">
                黑料八卦
              </span>
            </a>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
              给吃瓜群众备好闲聊话题的讨论区。围观有分寸，讨论有温度，茶余饭后翻两页，最新的瓜总在嘴边。
            </p>
            <div className="mt-5 flex flex-wrap gap-3">
              <a
                href="#discussion"
                className="flex h-10 w-10 items-center justify-center rounded-md bg-background-50 text-foreground-700 transition-colors hover:bg-primary-500 hover:text-background-50"
                aria-label="加入讨论区"
              >
                <i className="ri-chat-3-line text-lg" />
              </a>
              <a
                href="#zones"
                className="flex h-10 w-10 items-center justify-center rounded-md bg-background-50 text-foreground-700 transition-colors hover:bg-primary-500 hover:text-background-50"
                aria-label="浏览话题分区"
              >
                <i className="ri-compass-3-line text-lg" />
              </a>
              <a
                href="#subscribe"
                className="flex h-10 w-10 items-center justify-center rounded-md bg-background-50 text-foreground-700 transition-colors hover:bg-primary-500 hover:text-background-50"
                aria-label="订阅谈资"
              >
                <i className="ri-mail-line text-lg" />
              </a>
            </div>
          </div>

          {footerColumns.map((col) => (
            <div key={col.title} className="lg:col-span-2">
              <h4 className="font-heading text-sm font-semibold text-foreground-900">
                <a href="#top">{col.title}</a>
              </h4>
              <ul className="mt-4 flex flex-col gap-2.5">
                {col.links.map((link) => (
                  <li key={link}>
                    <a
                      href="#top"
                      className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="flex flex-col items-center justify-between gap-3 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} 黑料八卦 · 吃瓜群众的茶余饭后谈资
          </p>
          <p className="flex items-center gap-1.5 text-xs text-foreground-500">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-shield-check-line text-sm" />
            </span>
            理性围观 · 友善讨论
          </p>
        </div>
      </div>
    </footer>
  );
}